import { stylesheet } from 'typestyle';
import { flexRoot } from 'csstips';

import { regularGrayText, linkBlueText, lightGrayText } from '@styles/general';

const row = {
  ...flexRoot,

  marginLeft: -5,
  padding: '0 5px',

  $nest: {
    '&:hover': {
      background: '#efefef'
    }
  }
};

export default stylesheet({
  container: {
    fontSize: 14,
    position: 'relative'
  },

  header: {
    margin: '0 0 5px 0',
    fontWeight: 600,
    color: '#0a3d7e',
    fontSize: 14,
    lineHeight: '22px'
  },

  subheader: {
    margin: '0 0 0 0',
    fontWeight: 600,
    fontSize: 14,
    color: regularGrayText,
    lineHeight: '22px'
  },

  rows: {
    paddingBottom: 20,
    color: '#9b9b9b'
  },

  row,
  collapsibleRow: {
    ...row,

    $nest: {
      ...row.$nest,
      '.specifications.collapsed &': {
        display: 'none'
      }
    }
  },
  collapsibleSection: {
    $nest: {
      '.specifications.collapsed &': {
        display: 'none'
      }
    }
  },
  key: {
    color: regularGrayText,
    width: 115,

    a: {
      color: regularGrayText,
      textDecoration: 'underline'
    }
  },
  value: {
    width: 'calc(100% - 115px)',
    color: regularGrayText,
    textAlign: 'right'
  },
  viewMore: {
    borderTop: '1px solid #f0f0f0',
    color: linkBlueText,
    textAlign: 'center',
    paddingTop: 11,
    cursor: 'pointer',

    $nest: {
      '& .specifications--caret': {
        transform: 'rotate(225deg)',
        marginBottom: 3
      }
    }
  },
  viewLess: {
    borderTop: '1px solid #f0f0f0',
    color: linkBlueText,
    textAlign: 'center',
    paddingTop: 11,
    cursor: 'pointer',

    $nest: {
      '& .specifications--caret': {
        transform: 'rotate(45deg)'
      }
    }
  },
  caret: {
    borderLeft: `1px solid ${linkBlueText}`,
    borderTop: `1px solid ${linkBlueText}`,
    height: 5,
    width: 5,
    display: 'inline-block',
    marginLeft: 4
  },
  tabs: {
    margin: '0 -10px',
    width: 'calc(100% + 20px)'
  },
  tab: {
    cursor: 'pointer',
    display: 'inline-block',
    listStyle: 'none',
    textAlign: 'center',
    padding: '5px 0',
    width: '50%',

    $nest: {
      '&:not(.active)': {
        borderBottom: '1px solid #d4d4d4',
        color: lightGrayText
      },

      '&.active': {
        borderLeft: '1px solid #d4d4d4',
        borderTop: '1px solid #d4d4d4',
        borderRight: '1px solid #d4d4d4',
        color: linkBlueText,
        fontWeight: 'bold'
      },

      '&:nth-child(2)': {
        // Otherwise there is a 1px gap between on corner
        marginLeft: -1
      }
    }
  }
});
